// extracted by mini-css-extract-plugin
module.exports = {"TitleRow":"Datasheet_TitleRow__2vJue","SubTitleRow":"Datasheet_SubTitleRow__3piic"};